<div class="auth-layout-wrap">
  <div class="auth-content">
    <div class="card o-hidden">
      <div class="row">
        <div class="col-md-6">
          <div class="p-4">
            <div class="auth-logo text-center mb-4">
              <h1 class="font-weight-bold text-28 primary-text">Welcome to EDMS</h1>
            </div>
            <!--<h1 class="mb-3 text-22 text-center">Reset Password</h1>-->


            <app-update-password></app-update-password>


            <!--<div class="mt-3 text-center">
              <a class="text-muted" routerLink="/login">
                <u>Login</u>
              </a>
            </div>
-->
          </div>
        </div>
        <div class="col-md-6 text-center">
          <div class="pr-3 auth-right">
            <img src="assets/images/ministry_of_interior.jpg" alt="logo-nis">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
